<template>
  <div>
    <div class="modal fade" :class="{show: showMe}" :style="{display: display}" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style="padding-right: 17px; display: none;">
      <div class="modal-dialog modal-dialog-centered" :class="size" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade" :class="{show: showMe}"></div>
  </div>
</template>

<script>
export default {
  name: 'BsModal',
  props: ['show', 'size', 'no-margins'],
  data() {
    return {
      showMe: false,
      display: 'none'
    }
  },
  watch: {
    show(newVal) {
      this.display = newVal ? 'block' : 'none'
      const self = this
      setTimeout(() => {
        self.showMe = newVal
      }, 50)
    }
  },
  methods: {
    closeModal() {
      this.showMe = false
      const self = this
      setTimeout(() => {
        self.display = 'none'
        self.$emit('close-modal')
      }, 300)
    }
  }
};
</script>

<style lang="scss" scoped>
  button.close {
    position: absolute;
    right: -40px;
    top: -40px;
    width: 30px;
    color: #fff;
    text-shadow: none;
    opacity: 1;
  }

  .no-padding {
    .modal-content {
      background: none;
    }

    .modal-body {
      padding: 0;
      border-radius: 10px;
      overflow: hidden;
      background: none;
    }
  }

  .modal-content {
    border: none;
    box-shadow: 0 27px 49px rgba(0, 19, 63, .13);
  }
</style>
